/* eslint-disable no-unused-vars */
import { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import auth from '@/services/AuthService';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import useAppStore from '@/store/app';

export default function SetTotp({
  onSetupSuccess,
  onSetupFailure,
  setSelectedOption,
}) {
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const userToken = localStorage.getItem('userToken');
  const secureUID = localStorage.getItem('secureUID');

  const { setDialogForm } = useAppStore();

  useEffect(() => {
    setup2FA();
  }, []);

  const setup2FA = async () => {
    try {
      const response = await auth.post('/otp/generate/token', {
        userToken: userToken,
        secureUID: secureUID,
      });
      const { qrCodeLink, totpSecret } = response.data;

      setQrCode(qrCodeLink);
      setSecret(totpSecret);
    } catch (e) {
      onSetupFailure(
        'Fehler beim Einrichten der Zwei-Faktor-Authentifizierung',
      );
    }
  };

  const verifyToken = async (token) => {
    try {
      const response = await auth.post(
        '/otp/verify/token',
        JSON.stringify({
          userToken,
          token,
          secret,
          secureUID,
        }),
      );
      const { verified } = response.data;
      let confirmResp;
      if (verified) {
        confirmResp = await auth.post('/confirm', {
          token: userToken,
          sessionId: secureUID,
        });
      } else {
        document.getElementById('token-input').value = '';
        toast.error('Fehlerhafter Token. Versuchen Sie es erneut.');
        return;
      }

      if (confirmResp.status === 204) {
        setSecret('');
        setQrCode('');
        handleCloseDialog();
        onSetupSuccess();
      } else {
        onSetupFailure(
          'Fehler beim Aktivieren der Zwei-Faktor-Authentifizierung',
        );
      }
    } catch (e) {
      document.getElementById('token-input').value = '';
      onSetupFailure(e?.response?.data?.message);
    }
  };

  const handleCloseDialog = () => {
    setDialogForm(null);
    setSelectedOption(null);
  };

  return (
    <>
      <Dialog open={true} onClose={handleCloseDialog}>
        <DialogTitle gutterBottom>
          QR Code für Zwei-Faktor-Authentifizierung
        </DialogTitle>
        <DialogContent>
          {qrCode && (
            <Box display="flex" justifyContent="center" mb={2}>
              <img
                src={qrCode}
                alt="QR Code"
                style={{ width: '200px', height: '200px' }}
              />
            </Box>
          )}
          <Typography gutterBottom>
            Scannen Sie diesen QR-Code mit Ihrer Authenticator-App, um die
            Zwei-Faktor-Authentifizierung zu aktivieren.
          </Typography>
          <Typography gutterBottom>
            Wenn Sie keinen QR-Code-Scanner haben, können Sie den folgenden
            Schlüssel manuell eingeben:
          </Typography>

          <Box
            display="flex"
            justifyContent="center"
            mb={2}
            sx={{
              backgroundColor: '#f0f0f0',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <TextField
              disabled
              value={secret}
              variant="outlined"
              fullWidth
              placeholder="TOTP Token"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        navigator.clipboard.writeText(secret);
                      }}
                    >
                      <ContentCopy />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ wordBreak: 'break-word' }}
            />
          </Box>
          <Typography gutterBottom>
            Geben Sie nun einen Token ein, der von Ihrer Authenticator-App
            generiert wird, damit wir die Einrichtung abschließen können.
          </Typography>
          <TextField
            fullWidth
            label="Token eingeben"
            variant="outlined"
            inputMode="numeric"
            pattern="[0-9]*"
            id="token-input"
            autoFocus
            autoComplete="one-time-code"
            sx={{ mt: 2 }}
            InputProps={{ maxLength: 6 }}
            onChange={(e) => {
              if (e.target.value.length === 6) {
                verifyToken(e.target.value);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
